import React from 'react';
import { motion } from 'framer-motion';
import { FAQItem } from '../ui/FAQItem';
const faqs = [{
  question: 'Is this only for women?',
  answer: "Yes, currently HemNoMore is specifically designed for women's proportions and sizing, focusing on those under 5'4\"."
}, {
  question: 'What heights does this work for?',
  answer: 'Our system is optimized for women between 4\'10" and 5\'4". We have specific algorithms for different height brackets within that range.'
}, {
  question: 'Is the Fit Finder free?',
  answer: 'Yes, taking the Fit Finder quiz to discover your proportions is completely free.'
}, {
  question: 'Is this a subscription?',
  answer: 'Yes. After your free profile creation, we offer a monthly subscription that gives you curated picks, exclusive discounts, and new brand matches every month.'
}, {
  question: 'Can I cancel anytime?',
  answer: 'Absolutely. There are no long-term contracts or cancellation fees. You can pause or cancel your subscription at any moment from your account settings.'
}];
export function FAQ() {
  return <section className="py-24 bg-white" data-id="element-34">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4" data-id="element-37">
            Questions?
          </h2>
          <p className="text-text-muted" data-id="element-38">We're here to help clarify things.</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-primary/30 rounded-2xl p-6 md:p-8" data-id="element-39">
          {faqs.map((faq, index) => <FAQItem key={index} {...faq} data-id="element-40" />)}
        </motion.div>
      </div>
    </section>;
}